import { Helmet } from 'react-helmet-async';
import { Card } from 'components';
import styles from './Downsale.module.scss';
import OriginalAndNewAmount from './OriginalAndNewAmount';
import useDownsalePage from './useDownsalePage';
import { TwButton } from 'components/TwButton/TwButton';
import H2 from 'components/H/H2';
import H1 from 'components/H/H1';
import OfferTable from 'components/OfferTable/OfferTable';
import { useTranslation } from 'react-i18next';

export default function Downsale() {
  const { t } = useTranslation();
  const {
    originalAmount,
    newAmount,
    clientOfferData,
    isPending,
    handleOnSubmit,
  } = useDownsalePage();

  return (
    <>
      <Helmet>
        <title>{t('downsale:html_title')}</title>
      </Helmet>

      <H1 dataTest="downsale-title">{t('downsale:title')}</H1>

      <div className="flex flex-col gap-6" data-test="downsale-content">
        <div className="px-6 lg:px-0">
          <p
            className="text-center lg:text-left pb-4"
            data-test="downsale-sutitle"
          >
            {t('downsale:sub_title')}
          </p>

          <OriginalAndNewAmount
            originalAmount={originalAmount}
            newAmount={newAmount}
          />
        </div>

        <Card className={styles.card} dataTest="downsale-card">
          <div className="w-full pb-7" data-test="downsale-offer">
            <OfferTable
              totalPrincipal={clientOfferData?.totalPrincipal}
              totalRepayableAmount={clientOfferData?.totalRepayableAmount}
              extensionFees={clientOfferData?.extensionFees[30]}
              interestRate={clientOfferData?.interestRate}
              assignedInterest={clientOfferData?.assignedInterest}
              firstPaymentDate={clientOfferData?.firstPaymentDate}
              futureExtensionFees={
                clientOfferData?.futureExtensionFees?.[0]?.fee
              }
              loading={!clientOfferData}
            />
          </div>

          <TwButton
            data-test="downsale-button"
            pending={isPending}
            onClick={handleOnSubmit}
            disabled={isPending || !clientOfferData}
            className="mx-auto lg:mx-0"
          >
            {t('downsale:button')}
          </TwButton>
        </Card>
        <div className="px-6 lg:px-0">
          <H2 dataTest="downsale-info-title">{t('downsale:info_title')}</H2>

          <span
            data-test="downsale-info-text"
            dangerouslySetInnerHTML={{
              __html: t('downsale:info_text'),
            }}
          />
        </div>
      </div>
    </>
  );
}
